// a function that removes all \n and \t and html tags from a string
const removeHtmlTagsAndWhitespace = string => {

	string = string.replace(/<[^>]*>?/gm, "").replace(/\n/gm, "").replace(/\t/gm, "");
	string = string.trim();

	return string;
};

/**
 * add_shipping_info event
 */

// dedupe consecutive add_shipping_info events for the same shipping tier, so
// WooCommerce update_checkout re-renders can't re-emit the same event
// repeatedly. Enforced in the pmw:add-shipping-info listener further down, not
// here, because it has to cover the entry event as well: a third-party snippet
// reporting the tier the native trigger already reported is one selection, not
// two.
let lastShippingTierSlug = null;

// trigger the add_shipping_info event for a shipping tier
const triggerAddShippingInfoEvent = shippingTier => {

	if (!shippingTier) return;

	pmw.bus.emit("pmw:add-shipping-info", {shippingTier});
};

// The canonical shipping_method[<package>] inputs also exist in the cart page's
// shipping calculator and in cart drawers, so only report a shipping tier where
// a checkout is actually being filled out: either WooCommerce says we are on the
// checkout page, or a checkout form is present (custom and embedded checkouts
// such as CartFlows, where is_checkout() may not hold).
const isCheckoutContext = () =>
	"checkout" === pmwDataLayer?.shop?.page_type ||
	0 < jQuery("form.woocommerce-checkout").length;

// Read the shipping tier a shipping-method input represents. A package with a
// single available rate is rendered as a hidden input, so fall back to the rate
// slug rather than reporting an empty shipping_tier when no label is found.
const getShippingTierFromInput = input => {

	let element = jQuery(input);

	if (!element.val()) return null;
	if (!element.attr("id")) return null;

	let text = removeHtmlTagsAndWhitespace(jQuery("label[for='" + element.attr("id") + "']").text());

	return {
		slug: element.val(),
		text: text || element.val(),
	};
};

// trigger when a WooCommerce shipping method radio is changed
//
// Delegated on document, not on form.woocommerce-checkout: checkout skins such
// as CheckoutWC render their shipping step asynchronously and replace it on
// every checkout update, so a handler bound to the checkout form element is
// either attached before that form exists or lost with the next re-render.
//
// The canonical shipping_method[<package>] name filter stays the safety net so
// payment-method inputs (e.g. payment aggregators such as Autopay/BlueMedia
// that render many sub-channel radios) can never match and flood GA4 with bogus
// add_shipping_info events carrying payment names in shipping_tier.
jQuery(document).on("change", "input[name^='shipping_method']", (event) => {

	if (!isCheckoutContext()) return;

	triggerAddShippingInfoEvent(getShippingTierFromInput(event.target));
});

// Pick up a shipping method that was selected without a change interaction:
// already checked on page load, auto-selected by the checkout skin once the
// address is complete, or the hidden input of a single-rate package. The dedupe
// above collapses repeated checkout updates into one event per tier.
const scanForSelectedShippingMethod = () => {

	if (!isCheckoutContext()) return;

	// select the shipping-method input by its canonical name, not by a container
	// id, so we never pick up payment-method or other inputs
	let selectedShippingMethod = jQuery("input[name^='shipping_method']:checked, input[name^='shipping_method'][type='hidden']").first();

	if (!selectedShippingMethod.length) return;

	triggerAddShippingInfoEvent(getShippingTierFromInput(selectedShippingMethod));
};

// trigger when a shipping method is already selected on page load
jQuery(scanForSelectedShippingMethod);

// trigger after WooCommerce re-rendered the order review, which is how the
// shipping step arrives on checkouts that load it asynchronously
jQuery(document).on("updated_checkout", scanForSelectedShippingMethod);

/**
 * add_payment_info event
 */

	  // flag to prevent double logging of payment method change on pageload
let paymentMethodChangeLogged = false;

// trigger when a payment method is selected
jQuery("form.woocommerce-checkout").on("change", "input[name=\"payment_method\"]", event => {

	if (!event.target.value) return;
	if (!event.target.id) return;

	triggerAddPaymentInfoEvent({
		slug: event.target.value,
		text: removeHtmlTagsAndWhitespace(jQuery("label[for='" + event.target.id + "']").text()),
	});

	paymentMethodChangeLogged = true;
});

// trigger when a payment method is already selected on page load
jQuery(() => {

	// prevent double logging of payment method change on pageload
	if (paymentMethodChangeLogged) return;

	let checkedPaymentMethod = jQuery("input[name=\"payment_method\"]:checked");

	if (checkedPaymentMethod.length) {

		if (!checkedPaymentMethod.val()) return;
		if (!checkedPaymentMethod.attr("id")) return;

		triggerAddPaymentInfoEvent({
			slug: checkedPaymentMethod.val(),
			text: removeHtmlTagsAndWhitespace(jQuery("label[for='" + checkedPaymentMethod.attr("id") + "']").text()),
		});
	}
});

// trigger when a payment method is selected on page load
const triggerAddPaymentInfoEvent = paymentType => {
	pmw.bus.emit("pmw:add-payment-info", {paymentType});
};

/**
 * remove_from_cart event
 *
 * Cannot be attached directly because the mini cart doesn't necessarily contain the remove button on page load.
 */
jQuery(document).on("click", ".remove_from_cart_button, .remove", (event) => {

	// console.log("remove_from_cart event" + new Date().getTime())

	try {

		const href = jQuery(event.currentTarget).attr("href");
		if (!href) return;

		let productId = pmw.getProductIdByCartItemKeyUrl(new URL(href, window.location.href));

		/**
		 * The cart item key map can miss the clicked item: a cached cart fragment,
		 * a theme that renders its own cart markup, or the pmw_output_cart_item_data
		 * filter suppressing the inline script. Both WooCommerce remove controls
		 * carry the product ID themselves, so read it off the link rather than
		 * dropping the event. For a variation this is the parent product, which the
		 * variation ID from the key map would have beaten, but a parent-level
		 * remove_from_cart beats none at all. @since 1.67.1
		 */
		if (!productId) productId = jQuery(event.currentTarget).attr("data-product_id");

		pmw.removeProductFromCart(productId);

	} catch (e) {
		console.error(e);
	}
});


/**
 * begin_checkout event
 *
 * Cannot be attached directly because the mini cart doesn't necessarily contain the remove button on page load.
 */
let checkoutButtonClasses = [
	// ".checkout", // this is too generic. It triggers on the checkout page on some themes fore each interaction with the checkout form.
	".checkout-button",
	".cart-checkout-button",
	".button.checkout",
	".xoo-wsc-ft-btn-checkout", // https://xootix.com/side-cart-for-woocommerce/
	".elementor-button--checkout",
	".xt_woofc-checkout", // https://wordpress.org/plugins/woo-floating-cart-lite/
	".fkcart-checkout--text", // https://funnelkit.com/
];

const checkoutButtonSelectors = pmw.prepareSelectors(checkoutButtonClasses, "beginCheckout");

// https://wordpress.stackexchange.com/a/352171/68337
jQuery(document).on("click init_checkout", checkoutButtonSelectors, () => {
	pmw.bus.emit("pmw:begin-checkout");
});

jQuery(document).on("updated_cart_totals", () => {
	pmw.bus.emit("pmw:view-cart");
});

/**
 * WooCommerce Product Bundles and Composite Products: keep the container's
 * data-layer price in sync with the currently configured total.
 *
 * The server-rendered price is the container's static minimum. For bundles
 * that is 0 whenever every bundled item is optional, and for bundled
 * subscriptions whose up-front price is 0 (free trial, or the value sits in
 * the recurring fee). For composites it is the cheapest possible
 * configuration, so every upgraded option the shopper picks is missing from
 * it. Both extensions recalculate the assembled total client-side on every
 * configuration change and expose it through their public JS API. Mirror
 * that total into the product's data-layer entry so add_to_cart reports the
 * amount the shopper actually configured.
 *
 * Both APIs return the same totals shape ({price, regular_price,
 * price_incl_tax, price_excl_tax}), per single container: the container's
 * quantity input is not multiplied in, so downstream quantity handling stays
 * correct.
 */
const toContainerPrice = value => {

	// Both extensions seed their totals with empty strings until the first
	// calculation runs, and Number("") is 0, not NaN. Reject those explicitly
	// so an early read can never price a container at zero.
	if ("" === value || null === value || undefined === value) return null;

	let price = Number(value);

	return isFinite(price) ? price : null;
};

const setContainerPriceFromTotals = (containerId, totals) => {

	if (!containerId) return;
	if (!pmwDataLayer?.products?.[containerId]) return;
	if (!totals) return;

	// PMW outputs product prices including tax by default. Fall back to the
	// display price when the tax-inclusive total is not a usable number.
	let price = toContainerPrice(totals.price_incl_tax);
	if (null === price) price = toContainerPrice(totals.price);
	if (null === price) return;

	pmwDataLayer.products[containerId].price = price;
};

jQuery(document).on("woocommerce-product-bundle-updated-totals", ".bundle_data", (event, bundle) => {

	try {

		let bundleId = bundle?.bundle_id ? String(bundle.bundle_id) : String(jQuery(event.currentTarget).data("bundle_id") || "");
		let totals   = bundle?.api?.get_bundle_totals ? bundle.api.get_bundle_totals() : null;

		setContainerPriceFromTotals(bundleId, totals);

	} catch (e) {
		console.error(e);
	}
});

/**
 * When PMW loads after Product Bundles has already initialized (chunked or
 * lazy script loading), the initialization totals event above has already
 * fired and been missed. Sync the current totals of every initialized bundle
 * form once on load, so the default configuration is priced correctly even
 * when the shopper adds it to the cart without touching the form. Bundles
 * that initialize later are covered by the event listener above.
 *
 * Product Bundles mutates the same bundle_form_data object that jQuery's
 * .data() cache holds, so its totals field always reflects the live state.
 */
pmw.bus.on("pmwLoad", () => {

	try {

		jQuery(".bundle_form.initialized .bundle_data").each((index, element) => {

			let $element = jQuery(element);

			setContainerPriceFromTotals(
				String($element.data("bundle_id") || ""),
				$element.data("bundle_form_data")?.totals,
			);
		});

	} catch (e) {
		console.error(e);
	}
});

/**
 * WooCommerce Composite Products: keep the composite container's data-layer
 * price in sync with the currently configured composite total.
 *
 * Composite Products keeps the value of a configurable composite on its
 * composited child items, so the container's server-side price is the
 * cheapest possible configuration. Every option the shopper upgrades to is
 * missing from it, which under-reports add_to_cart by the difference.
 *
 * Composite Products has no jQuery totals event. It exposes an internal
 * action dispatcher instead, which is available on the composite object the
 * moment the pre-init 'wc-composite-initializing' event is triggered on its
 * .composite_data container, long before the totals are first calculated.
 */
const hookCompositeTotals = composite => {

	if (!composite) return;
	if (composite.pmwTotalsHooked) return;
	if (!composite.actions?.add_action) return;
	if (!composite.api?.get_composite_totals) return;

	composite.pmwTotalsHooked = true;

	// The container id is the composite product's own id, which is the key
	// the composite is written to the data layer under.
	let compositeId = String(composite.composite_id || "");

	let syncPrice = () => setContainerPriceFromTotals(compositeId, composite.api.get_composite_totals());

	// 'composite_initialized' prices the default configuration, so a composite
	// added to the cart without touching the form is reported correctly too.
	composite.actions.add_action("composite_initialized", syncPrice, 100, composite);
	composite.actions.add_action("composite_totals_changed", syncPrice, 100, composite);
};

jQuery(document).on("wc-composite-initializing", ".composite_data", (event, composite) => {

	try {
		hookCompositeTotals(composite);
	} catch (e) {
		console.error(e);
	}
});

/**
 * When PMW loads after Composite Products has already initialized (chunked or
 * lazy script loading), the pre-init event above has already been triggered
 * and missed. Composite Products keeps every composite of the page in the
 * global wc_cp_composite_scripts registry, so pick them up from there, price
 * their current configuration once, and hook them for later changes.
 */
pmw.bus.on("pmwLoad", () => {

	try {

		if (typeof wc_cp_composite_scripts === "undefined") return;

		jQuery.each(wc_cp_composite_scripts, (containerId, composite) => {

			hookCompositeTotals(composite);

			if (!composite?.is_initialized) return;
			if (!composite.api?.get_composite_totals) return;

			setContainerPriceFromTotals(String(containerId), composite.api.get_composite_totals());
		});

	} catch (e) {
		console.error(e);
	}
});

/**
 * Set up PWM events
 */

// track checkout option event: purchase click
// https://wordpress.stackexchange.com/a/352171/68337
pmw.bus.on("pmwLoad", () => {
	jQuery(document).on("payment_method_selected", () => {

		if (false === pmw.paymentMethodSelected) {
			pmw.fireCheckoutProgress(3);
		}

		pmw.fireCheckoutOption(3, jQuery("input[name='payment_method']:checked").val());
		pmw.paymentMethodSelected = true;
	});
});

// populate the pmwDataLayer with the cart items
pmw.bus.on("pmwLoad", () => {

	try {
		pmw.initCart();
	} catch (e) {
		console.error(e);
	}
});

/**
 * Keep the stored cart hash in sync with client-tracked cart changes.
 *
 * WooCommerce passes the fresh cart hash with these events after every AJAX
 * cart mutation. Recording it prevents initCart from treating our own tracked
 * changes as a server-side desync and re-fetching the cart on the next page.
 * Cart changes without these events (non-AJAX form adds, server-side changes)
 * are reconciled by initCart through a one-time backend fetch instead.
 */
jQuery(document.body).on("added_to_cart removed_from_cart", (event, fragments, cartHash) => {

	try {
		if (cartHash) pmw.storeData("cart_hash", cartHash);
	} catch (e) {
		console.error(e);
	}
});

// get all add-to-cart= products from backend
pmw.bus.on("pmwLoad", () => {

	pmwDataLayer.products = pmwDataLayer.products || {};

	// scan page for add-to-cart= links
	let productIds = pmw.getAddToCartLinkProductIds();

	pmw.getProductsFromBackend(productIds);
});

/**
 * Save the referrer into a cookie
 *
 * @returns {void}
 */
pmw.bus.on("pmwLoad", () => {

	// If there is no referrer, then return
	if (!document.referrer) {
		return;
	}

	// If the referrer is already stored, then return
	if (pmw.retrieveData("referrer")) {
		return;
	}

	let referrerUrl      = new URL(document.referrer);
	let referrerHostname = referrerUrl.hostname;

	if (referrerHostname !== window.location.host) {
		pmw.storeData("referrer", referrerHostname);
	}
});

/**
 * The click IDs PMW harvests from landing page URLs: storage key => URL
 * parameter. Only Snap spells its parameter differently from the key.
 *
 * - gclid, wbraid, gbraid: Google Ads
 * - fbclid: Meta, https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc
 * - ttclid: TikTok
 * - scid (ScCid): Snapchat
 * - epik: Pinterest
 * - oppref: OpenAI (ChatGPT), https://developers.openai.com/ads/conversions-api
 * - ndclid: Nextdoor, https://developer.nextdoor.com/reference/conversion-user-matching
 * - msclkid: Microsoft, https://learn.microsoft.com/en-us/advertising/guides/uet-conversion-api-integration#click-id-msclkid
 * - rdt_cid: Reddit, https://business.reddithelp.com/s/article/manual-conversion-events-with-the-reddit-pixel
 * - aleid: AppLovin, https://support.applovin.com/en/growth/promoting-your-websites/api/axon-conversion-api
 */
pmw.clickIdUrlParameters = {
	gclid  : "gclid",
	wbraid : "wbraid",
	gbraid : "gbraid",
	fbclid : "fbclid",
	ttclid : "ttclid",
	scid   : "ScCid",
	epik   : "epik",
	oppref : "oppref",
	ndclid : "ndclid",
	msclkid: "msclkid",
	rdt_cid: "rdt_cid",
	aleid  : "aleid",
}

/**
 * Whether click IDs may be stored in this browser. A click ID is personal
 * data, and keeping it in sessionStorage is storage the ePrivacy rules tie to
 * consent. In Explicit Consent Mode nothing is stored before marketing
 * consent; in implicit mode the click ID is held until the visitor decides
 * (sending is gated on its own), and a visitor who denied marketing gets
 * nothing stored. Mirrors Click_Ids::is_collection_allowed() (DD-043).
 *
 * @returns {boolean}
 * @since 1.69.3
 */
pmw.isClickIdCollectionAllowed = () => {

	if (pmw.consent.categories.get().marketing === true) return true

	if (pmw.consent.explicitConsentModeActive()) return false

	return !pmw.visitorHasDecidedConsent()
}

/**
 * Whether the visitor has made a consent decision: on an earlier page
 * (visitorHasChosen) or on this one, through a CMP event or the consent API.
 *
 * @returns {boolean}
 * @since 1.69.3
 */
pmw.visitorHasDecidedConsent = () =>
	pmw.consent.settings.get().visitorHasChosen === true
	|| pmw.consent.decisionRecorded?.() === true

/**
 * Collects the click IDs from the URL into PMW's session storage.
 *
 * Only the platforms this shop has configured, where the server publishes
 * that list (Pro), and only while collection is allowed. Runs on load and
 * again when consent is granted, so a visitor who accepts on the landing
 * page still keeps the click IDs of that URL.
 *
 * @returns {void}
 * @since 1.69.3
 */
pmw.harvestClickIdsFromUrl = () => {

	if (!pmw.isClickIdCollectionAllowed()) return

	const activeKeys = pmwDataLayer?.general?.click_id_keys

	for (const [key, parameter] of Object.entries(pmw.clickIdUrlParameters)) {

		if (Array.isArray(activeKeys) && !activeKeys.includes(key)) continue

		let value = pmw.getUrlParameter(parameter)

		if (!value) continue

		if (key === "fbclid") {

			// The same click harvested again (consent granted later on the
			// same page) keeps its original creation time.
			const stored = pmw.retrieveData("fbclid")
			if (typeof stored === "string" && stored.endsWith("." + value)) continue

			// fbc format: fb.<subdomainIndex>.<creationTimeMs>.<fbclid>
			// The creation time must be in milliseconds (13 digits). Meta's fbevents.js
			// writes it that way, and PMW's isValidFbc / is_valid_fbc validators enforce
			// exactly 13 digits (\d{13}), so a seconds-based timestamp would be dropped.
			value = "fb.1." + Date.now() + "." + value
		}

		pmw.storeData(key, value)
	}
}

/**
 * Removes every click ID PMW stored in this browser: the session storage
 * copies and the first-party fallback cookie. The server removes its copy
 * when the next transfer reports the new consent state.
 *
 * @returns {void}
 * @since 1.69.3
 */
pmw.purgeClickIds = () => {

	for (const key of Object.keys(pmw.clickIdUrlParameters)) {
		if (pmw.retrieveData(key) !== undefined) pmw.deleteDataKey(key)
	}

	// A later grant must be able to send the same identifiers again.
	if (pmw.retrieveData("pmw_identifiers_sent") !== undefined) pmw.deleteDataKey("pmw_identifiers_sent")

	// _pmw_click_ids is the cookie's name before 1.69.3.
	for (const name of ["pmw_click_ids", "_pmw_click_ids"]) {
		if (pmw.getCookie(name)) pmw.deleteCookie(name)
	}
}

pmw.bus.on("pmwLoad", () => {
	pmw.harvestClickIdsFromUrl()
})

/**
 * A grant harvests the URL of the current page, a denial or withdrawal
 * purges what was stored. Registered before the Pro listener that transfers
 * the identifiers to the server, so that transfer already sees the result.
 */
document.addEventListener("pmw:consent:update", () => {

	if (pmw.isClickIdCollectionAllowed()) {
		pmw.harvestClickIdsFromUrl()
	} else {
		pmw.purgeClickIds()
	}
})

/**
 * Log why the order confirmation page reports no purchase.
 *
 * The order duplication prevention holds back the purchase of an order that
 * was already reported, either on the server (the conversion pixel fired flag
 * on the order, so the data layer carries order_suppressed instead of order) or
 * in this browser (the order ID is in storage). Both used to stay silent, and
 * a merchant reloading a confirmation page took the purchase tracking for
 * broken. One line, visible with pmwloggeron, names the nodedupe parameter
 * that lets the purchase be tested again.
 *
 * @since 1.71.1
 */
pmw.logSuppressedPurchase = () => {

	const howToTest = "To test the purchase again, add the nodedupe parameter to the order confirmation URL (for example &nodedupe), or turn off the order duplication prevention."

	if (pmwDataLayer?.order_suppressed === "already_fired") {
		pmw.console.log("Purchase not reported: it was suppressed because the conversion pixels already fired for this order (order duplication prevention). " + howToTest)
		return
	}

	if (pmwDataLayer?.order) {
		pmw.console.log("Purchase not reported: it was suppressed because this browser already reported order " + pmwDataLayer.order.id + " (order duplication prevention). " + howToTest)
		return
	}

	pmw.console.log("Purchase not reported: the page carries no order data. The order was not found, or its status, a user role excluded from tracking or the pmw_conversion_prevention filter held it back.")
}

/**
 * Create our own load event in order to better handle script flow execution when JS "optimizers" shuffle the code.
 */
pmw.bus.on("pmwLoad", () => {
	// document.addEventListener("pmwLoad", function () {
	try {
		if (typeof pmwDataLayer != "undefined" && !pmwDataLayer?.pmw_loaded) {

			pmw.bus.emit("pmw:load-always");

			if (pmwDataLayer?.shop) {
				if (
					"product" === pmwDataLayer.shop.page_type &&
					"variable" !== pmwDataLayer.shop.product_type &&
					pmw.getMainProductIdFromProductPage()
				) {
					let product = pmw.getProductDataForViewItemEvent(pmw.getMainProductIdFromProductPage());
					pmw.bus.emit("pmw:view-item", product);
				} else if (
					"product" === pmwDataLayer.shop.page_type &&
					"variable" === pmwDataLayer.shop.product_type &&
					(
						!pmwDataLayer?.shop?.variations_output ||
						true === pmwDataLayer?.shop?.parent_view_item_on_variable_products
					) &&
					pmw.getMainProductIdFromProductPage()
				) {
					// Fire view_item with the parent product data. Either variations are not
					// reported separately at all, or the shop asked for the parent event
					// through the pmw_fire_parent_view_item_on_variable_products filter, in
					// which case the variation's own view_item still follows from
					// show_variation once the visitor picks one.
					let product = pmw.getProductDataForViewItemEvent(pmw.getMainProductIdFromProductPage());
					pmw.bus.emit("pmw:view-item", product);
				} else if ("product_category" === pmwDataLayer.shop.page_type) {
					pmw.bus.emit("pmw:view-category");
				} else if ("search" === pmwDataLayer.shop.page_type) {
					pmw.bus.emit("pmw:search");
				} else if ("cart" === pmwDataLayer.shop.page_type) {
					pmw.bus.emit("pmw:view-cart");
				} else if ("order_received_page" === pmwDataLayer.shop.page_type) {
					if (pmwDataLayer?.order && !pmw.isOrderIdStored(pmwDataLayer.order.id)) {
						pmw.bus.emit("pmw:purchase");
						pmw.writeOrderIdToStorage(pmwDataLayer.order.id, pmwDataLayer.order.key);
						if (typeof pmw.acrRemoveCookie === "function") pmw.acrRemoveCookie();
					} else {
						pmw.logSuppressedPurchase();
					}
				} else {
					pmw.bus.emit("pmw:everywhere-else");
				}
			} else {
				pmw.bus.emit("pmw:everywhere-else");
			}

			// Whether the visitor is signed in is general.user_logged_in, which
			// is is_user_logged_in() for this request. It is not user.id: on
			// the order confirmation page the user object is filled from the
			// order's customer on purpose, so that the purchase carries the
			// buyer's identifiers even on a payment webhook or a scheduled
			// run. Reading user.id as "signed in" made every guest checkout of
			// a registered customer emit a login on the confirmation page, for
			// a visitor who had never signed in, and every pixel listening to
			// pmw:pixel:login acted on it. user.id is still required because
			// the user object only exists on Pro, and a login event without
			// any identity has nothing to report.
			if (pmwDataLayer?.general?.user_logged_in && pmwDataLayer?.user?.id && !pmw.hasLoginEventFired()) {
				pmw.bus.emit("pmw:login");
				pmw.setLoginEventFired();
			}

			if (pmwDataLayer?.user?.account_just_created && !pmw.hasAccountCreatedEventFired()) {
				pmw.bus.emit("pmw:account-created");
				pmw.setAccountCreatedEventFired();
			}

			pmwDataLayer.pmw_loaded = true;
		}

	} catch (e) {
		console.error(e);
	}
});

/**
 * Register the show_variation event listener
 * in case lazy loading is enabled
 * because we have to register it immediately
 * and not after the onready event.
 */
if (pmwDataLayer?.general?.lazy_load_pmw) {
	pmw.registerShowVariationEventListener();
}

/**
 * In case lazy loading is enabled
 * we need to trigger the view-item event on
 * preselected variations.
 *
 * Check if a variation is selected on a variable product page
 * and trigger the view-item event if a variation is selected
 *
 * Fallback for the jQuery(".single_variation_wrap").on("show_variation", (event, variation) => {}) event listener
 * in case lazy loading is enabled and the event listener is not triggered.
 *
 * Only fires if variations_output is enabled, as the parent product view_item
 * is already triggered on page load when variations_output is disabled.
 */
pmw.bus.on("pmwLoad", () => {
	if (!pmwDataLayer?.general?.lazy_load_pmw) return;
	if (!pmwDataLayer?.shop?.variations_output) return;

	try {
		const $variationForm = jQuery(".variations_form");
		if (!$variationForm.length) return;

		const selectedValues = {};
		const allSelected    = $variationForm.find("select").toArray().every(select => {
			const value = jQuery(select).val();
			if (value) {
				selectedValues[jQuery(select).attr("name")] = value;
				return true;
			}
			return false;
		});

		if (!allSelected) return;

		const productVariations = $variationForm.data("product_variations");
		if (!productVariations) return;

		const matchingVariation = productVariations.find(variation =>
			Object.entries(selectedValues).every(([key, value]) =>
				variation.attributes[key] === value,
			),
		);

		if (matchingVariation) {
			pmw.triggerViewItemEventPrep(matchingVariation.variation_id);
		}
	} catch (e) {
		pmw.console.error(e);
	}
});

// Check if the REST endpoint is available and log an error if it is not
pmw.bus.on("pmwLoad", async () => {
	if (pmw.getRestStatus() === false) pmw.console.error("REST endpoint is not available. Using admin-ajax.php instead.");
});

/**
 * All s2s events
 */

/**
 * PageView event
 *
 * Uses the unified event processing system with filters.
 * Each pixel's adapter handles the data transformation.
 * S2S transmission is controlled by the supportsPageViewS2S capability.
 */
pmw.bus.on("pmw:page-view", async () => {

	pmw.console.log("pmw:page-view event fired");

	// Use the unified event processor
	const payload = await pmw.processEvent("page_view", {});

	// The processor returns nothing when it recognised the event as the same
	// one it just handled, in which case there is no payload to send on.
	if (!payload) return;

	// Only send to server if pageview S2S is enabled AND there are pixels with this capability
	if (pmwDataLayer?.general?.server_2_server?.pageview_event_s2s?.is_active) {
		const pageViewS2SPixels = pmw.pixelRegistry.getPixelsWithCapability("supportsPageViewS2S");

		if (pageViewS2SPixels.length > 0) {

			// Run the server-side enrichment phase (e.g. wait for Facebook's _fbp cookie)
			// before building the S2S payload. The browser pixel has already fired above.
			await pmw.enrichServerPixels(payload, pageViewS2SPixels);

			// Extract S2S data only for pixels that support pageview S2S
			const s2sData = {event: "page_view"};

			for (const pixelName of pageViewS2SPixels) {
				if (payload.pixels[pixelName]) {
					s2sData[pixelName] = payload.pixels[pixelName];
				}
			}

			if (Object.keys(s2sData).length > 1) { // More than just 'event' key
				pmw.sendEventPayloadToServer(s2sData);
			}
		}
	}
});

/**
 * Add to cart event
 *
 * Uses the new unified event processing system with filters
 */
pmw.bus.on("pmw:add-to-cart", async (product) => {

	pmw.console.log("pmw:add-to-cart event fired", {product});

	// Use the new unified event processor
	await pmw.processEvent("add_to_cart", {
		product: product,
	});
});

/**
 * Remove from cart event
 * Uses the new unified event processing system with filters
 */
pmw.bus.on("pmw:remove-from-cart", async (product) => {

	pmw.console.log("pmw:remove-from-cart event fired", {product});

	// Use the new unified event processor
	await pmw.processEvent("remove_from_cart", {
		product: product,
	});
});

/**
 * Select item event
 * Uses the new unified event processing system with filters
 */
pmw.bus.on("pmw:select-item", async (product) => {

	pmw.console.log("pmw:select-item event fired", {product});

	// Use the new unified event processor
	await pmw.processEvent("select_item", {
		product: product,
	});
});

/**
 * View cart event
 */
pmw.bus.on("pmw:view-cart", () => {

	pmw.console.log("pmw:view-cart event fired");

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("view_cart", {});
});

/**
 * Begin checkout event
 */
pmw.bus.on("pmw:begin-checkout", () => {

	pmw.console.log("pmw:begin-checkout event fired");

	// Remember that a begin_checkout fired for the current cart, so the
	// checkout-page-load trigger below doesn't duplicate it. The flag is
	// reset in pmw.initCart when the WooCommerce cart ceases to exist.
	// Never let a storage failure block the event itself.
	try {
		pmw.storeData("begin_checkout_fired", true);
	} catch (e) {
		pmw.console.error(e);
	}

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("begin_checkout", {});
});

/**
 * Begin checkout on checkout page load
 *
 * Shoppers can reach the checkout page without clicking a "proceed to
 * checkout" button: funnel builders (e.g. CartFlows next-step buttons that
 * add the product server-side while the checkout page renders), buy-now
 * buttons, direct checkout links, or block-based carts whose checkout links
 * don't match the click selectors above. In those flows the click trigger
 * never runs, so fire begin_checkout when the checkout page loads instead.
 *
 * Deduplicated against every other begin_checkout path through the session
 * flag stamped in the pmw:begin-checkout listener above: a shopper who did
 * click a checkout button doesn't produce a second event when the checkout
 * page then loads. Fires only when the WooCommerce cart has items.
 *
 * Can be disabled with the pmw_fire_begin_checkout_on_checkout_page filter.
 */
pmw.bus.on("pmwLoad", () => {

	try {
		if ("checkout" !== pmwDataLayer?.shop?.page_type) return;
		if (true !== pmwDataLayer?.shop?.begin_checkout_on_checkout_page) return;
		if (pmw.hasBeginCheckoutFired()) return;
		if (!pmw.doesWooCommerceCartExist()) return;

		pmw.triggerBeginCheckoutWhenCartReady();

	} catch (e) {
		console.error(e);
	}
});

/**
 * Add Shipping Info
 */
pmw.bus.on("pmw:add-shipping-info", (data = {}) => {

	pmw.console.log("pmw:add-shipping-info event fired", {data});

	// One shipping selection is one event, no matter which path reported it:
	// the native triggers above fire again on every checkout re-render, and
	// third-party snippets written for checkout skins we did not support yet
	// dispatch the same tier alongside them. The blocks checkout reports its
	// shipping address instead of a tier and keeps its own debounce.
	const shippingTierSlug = data?.shippingTier?.slug;

	if (shippingTierSlug) {
		if (shippingTierSlug === lastShippingTierSlug) return;
		lastShippingTierSlug = shippingTierSlug;
	}

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("add_shipping_info", data);
});

/**
 * Bring every report of a payment selection into one shape,
 * {paymentType: {slug, text}}, so the adapters and the duplicate guard
 * read the same fields no matter which path reported it.
 *
 * The classic checkout and the Checkout block DOM fallback already send
 * that shape. The Checkout block action only knows the slug, and snippets
 * may pass the method as a plain string.
 *
 * @since 1.69.3
 * @param {object} data
 * @returns {object}
 */
const normalizeAddPaymentInfoData = (data = {}) => {

	if (!data || "object" !== typeof data) return {};

	let paymentType = data.paymentType;

	if ("string" === typeof paymentType) paymentType = {slug: paymentType};

	if (!paymentType || "object" !== typeof paymentType) return data;

	const slug = paymentType.slug || paymentType.text;
	const text = paymentType.text || paymentType.slug;

	if (!slug) return data;

	return {
		...data,
		paymentType: {
			...paymentType,
			slug: String(slug),
			text: String(text),
		},
	};
};

/**
 * Add Payment Info
 */
pmw.bus.on("pmw:add-payment-info", (data = {}) => {

	pmw.console.log("pmw:add-payment-info event fired", {data});

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("add_payment_info", normalizeAddPaymentInfoData(data));
});

/**
 * Add Contact Info
 *
 * The shopper has given an email address or phone number in the checkout
 * form. Pixels whose funnel events need an identity before an order exists
 * (Triple Whale) pick it up from here; everything else ignores it.
 *
 * All three sources (classic checkout fields, the Checkout block action and
 * the Interactivity API fallback) report on every change, so one identity is
 * one event: the email has to be complete and the pair must differ from the
 * last one reported.
 */
let lastContactKey = "";

pmw.bus.on("pmw:add-contact-info", (data = {}) => {

	const email = pmw.isEmail(data?.email) ? String(data.email).trim() : "";
	const phone = data?.phone ? String(data.phone).trim() : "";

	if (!email && !phone) return;

	const contactKey = email + "|" + phone;

	if (contactKey === lastContactKey) return;
	lastContactKey = contactKey;

	pmw.console.log("pmw:add-contact-info event fired", {data});

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("add_contact_info", {...data, email, phone});
});

/**
 * Report the checkout form's current contact details.
 *
 * @param {Object} [contact] Defaults to what the form holds right now.
 */
pmw.emitCheckoutContact = (contact) => {
	pmw.bus.emit("pmw:add-contact-info", contact || pmw.platform.getCheckoutContact());
};

/**
 * Add to wishlist event
 *
 * Uses the unified event processing system with filters.
 * Each pixel's adapter handles the data transformation.
 */
pmw.bus.on("pmw:add-to-wishlist", async (product) => {

	pmw.console.log("pmw:add-to-wishlist event fired", {product});

	// Use the unified event processor
	await pmw.processEvent("add_to_wishlist", {
		product: product,
	});
});

/**
 * View Item List event
 */
pmw.bus.on("pmw:view-item-list", (product = null) => {

	pmw.console.log("pmw:view-item-list event fired", {product});

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("view_item_list", {
		product: product,
	});
});

/**
 * The product the last view_item on this page reported on, undefined until
 * the first one goes out.
 *
 * @type {string|null|undefined}
 */
let lastViewItemProductId;

/**
 * View Item event
 *
 * A variation that WooCommerce preselects is announced twice: once by the
 * page-load path that reads the selection off the variation form, and once
 * by WooCommerce's own show_variation event. Each pass produces its own
 * event ID, so the destination counts two product views for one page load.
 * The two are far enough apart in time when the product still has to be
 * fetched from the backend that the processor's own duplicate window cannot
 * be relied on, so the same product twice in a row is dropped here. Viewing
 * another variation and coming back still reports both views.
 */
pmw.bus.on("pmw:view-item", (product = null) => {

	pmw.console.log("pmw:view-item event fired", {product});

	const productId = product?.id ?? null;

	if (undefined !== lastViewItemProductId && productId === lastViewItemProductId) {
		pmw.console.log("Skipping view_item: this product was already reported on this page");
		return;
	}

	lastViewItemProductId = productId;

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("view_item", {
		product: product,
	});
});

/**
 * View category event
 *
 * Uses the unified event processing system with filters.
 * Each pixel's adapter handles the data transformation.
 */
pmw.bus.on("pmw:view-category", async (product = null) => {

	pmw.console.log("pmw:view-category event fired", {product});

	// Use the unified event processor
	await pmw.processEvent("view_category", {
		product: product,
	});
});

/**
 * Search event
 */
pmw.bus.on("pmw:search", () => {

	pmw.console.log("pmw:search event fired");

	/**
	 * Process the event through the unified event processor
	 */
	pmw.processEvent("search", {});
});

/**
 * Place order event
 *
 * Uses the unified event processing system with filters.
 * Each pixel's adapter handles the data transformation.
 */
pmw.bus.on("pmw:place-order", async () => {

	pmw.console.log("pmw:place-order event fired");

	// Use the unified event processor
	await pmw.processEvent("place_order", {});
});

/**
 * Purchase event
 */
pmw.bus.on("pmw:purchase", async () => {

	pmw.console.log("pmw:purchase event fired");

	// Use the unified event processor
	await pmw.processEvent("purchase", {
		order: pmwDataLayer.order,
	});
});

/**
 * Login event
 *
 * Uses the unified event processing system with filters.
 * Each pixel's adapter handles the data transformation.
 */
pmw.bus.on("pmw:login", async () => {

	pmw.console.log("pmw:login event fired");

	// Use the unified event processor
	await pmw.processEvent("login", {});
});

/**
 * Account created event
 *
 * Uses the unified event processing system with filters.
 * Each pixel's adapter handles the data transformation.
 */
pmw.bus.on("pmw:account-created", async () => {

	pmw.console.log("pmw:account-created event fired");

	// Use the unified event processor
	await pmw.processEvent("account_created", {});
});

/**
 * Run WooCommerce specific functions
 */
pmw.bus.on("pmw:ready", async () => {

	// Only run if WooCommerce is active
	if (!pmw.isWooCommerceActive()) {
		return;
	}

	/**
	 * Run as soon as wpm namespace is loaded
	 */

	// Watch for products visible in viewport
	pmw.startIntersectionObserverToWatch();

	// Watch for lazy loaded products
	pmw.startProductsMutationObserverToWatch();

	// Watch for content rendered client-side by blocks running on the
	// Interactivity API: re-binds the element-scoped listeners, injects the
	// product markers the blocks don't carry, and hands the new products to
	// the intersection observer.
	pmw.startInteractivityDomObserver();
});

pmw.bus.on("pmw:load-pixels", () => {
	pmw.waitForPixelsAndTriggerPageView();
});
